module.exports = __webpack_public_path__ + "img/c-interview.52cb56b4.png";